export const DISCARD_WORKSPACE_CHANGES_EVENT = 'megatraderdx:discard-workspace-changes';
